<!-- eslint-disable vue/no-v-model-argument -->
<template>
  <div class="grid lg:flex-column lg:h-full m-0 lg:overflow-hidden">
    <div class="col-12 flex-grow-1 lg:col-4 p-0 stepper relative z-0" :class="{ 'stepper-with-reviews': store.useGoogleReviewsDesktop }">
      <LeftStepperComponent :style="[ store.isMobile ? '' : 'height: 80vh;' ]" />
      <div v-if="store.useGoogleReviewsDesktop" class="google-reviews-slot">
        <GoogleReviewsComponent
          :rating="store.googleReviews.rating"
          :reviews="store.googleReviews.reviews"
          :url="store.googleReviews.url"
        />
      </div>
      <div v-if="!store.isMobile && store.form.stepper_bg_img_folder && imageExists(`${useRuntimeConfig().public.appUrl}/imgs/stepper_bg_img/${store.form.stepper_bg_img_folder}/stepper_bg_img.png`)">
        <div class="text-left absolute bottom-0 mentions w-full">
          <span class="ml-2 p-2 cursor-pointer" @click="handleDialog">Mentions légales</span>
        </div>
        <img
          class="stepper-bg-img"
          :src="getImgUrl(`${useRuntimeConfig().public.appUrl}/imgs/stepper_bg_img/${store.form.stepper_bg_img_folder}/stepper_bg_img.png`)"
        >
      </div>
      <div v-else-if="!store.isMobile && (!store.form.stepper_bg_img_folder || !imageExists(`${useRuntimeConfig().public.appUrl}/imgs/stepper_bg_img/${store.form.stepper_bg_img_folder}/stepper_bg_img.png`))">
        <div class="text-center absolute bottom-0 mentions w-full">
          <span class="ml-2 p-2 cursor-pointer" @click="handleDialog">Mentions légales</span>
        </div>
      </div>
    </div>
    <div class="col-12 flex-grow-1 lg:col-8 p-0 form">
      <slot />
    </div>
    <MentionsModalComponent :show-dialog="showDialog" @update-show-dialog="handleDialog" />
  </div>
</template>
<script setup lang="ts">
import { useStore } from "@/stores/store";

const store = useStore();
const showDialog = ref(false);

function imageExists (imageUrl) {
  const http = new XMLHttpRequest();
  http.open("HEAD", imageUrl, false);
  http.send();

  return http.status !== 404;
}

function handleDialog () {
  showDialog.value = !showDialog.value;
}
</script>
